import { useQuery, QueryFunction } from 'react-query';
import {
    getLatestTemplates,
    getLatestPublishedTemplates,
    getTemplateById,
    getTemplatesByGroupId,
    FormTemplate,
    GetByIdFormTemplateQueries,
    GetLatestFormTemplatesQueries,
    FormTemplateWithSections,
} from '../../services/apiSLTP/qhse/forms/formTemplates';

// ---------------- TYPES ----------------
type UseLatestTemplatesQueryOptions = {
    queries?: GetLatestFormTemplatesQueries;
};

type UseTemplateByIdQueryOptions = {
    id: string;
    queries?: GetByIdFormTemplateQueries;
};

type UseGroupTemplatesQueryOptions = {
    groupId: string;
};

// ---------------- QUERY FUNCTIONS ----------------
const getLatestFormTemplates: QueryFunction<FormTemplate[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseLatestTemplatesQueryOptions];
    const { queries } = options || {};
    const response = await getLatestTemplates(queries);
    return response.data;
};

const getLatestPublishedFormTemplates: QueryFunction<FormTemplate[]> = async () => {
    const response = await getLatestPublishedTemplates();
    return response.data;
};

const getFormTemplateById: QueryFunction<FormTemplateWithSections> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseTemplateByIdQueryOptions];
    const response = await getTemplateById(options.id, options.queries);
    return response.data;
};

const getFormTemplatesByGroupId: QueryFunction<FormTemplate[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseGroupTemplatesQueryOptions];
    const response = await getTemplatesByGroupId(options.groupId);
    return response.data;
};

// ---------------- HOOKS ----------------
export const useLatestFormTemplatesQuery = (options: UseLatestTemplatesQueryOptions = {}) => {
    return useQuery(['latestFormTemplates', options], getLatestFormTemplates);
};

export const useLatestPublishedFormTemplatesQuery = () => {
    return useQuery(['latestPublishedFormTemplates'], getLatestPublishedFormTemplates);
};

export const useFormTemplateByIdQuery = (options: UseTemplateByIdQueryOptions) => {
    return useQuery(['formTemplate', options], getFormTemplateById, { enabled: !!options.id });
};

export const useFormTemplatesByGroupIdQuery = (options: UseGroupTemplatesQueryOptions) => {
    return useQuery(['formTemplatesByGroupId', options], getFormTemplatesByGroupId, { enabled: !!options.groupId });
};
